/* Studio Zen installations, drawn from the approved submissions (install-uploads/Code.gs, GET ?gallery=1).
   Used by sections/szw-installs-live (gallery page + homepage strip) and sections/szw-product-installs.
   Every project shows what is on the wall (pattern + SKU, linked to that colorway) and full credits.
   Markup contract: <div data-szw-installs data-endpoint=".." data-mode="page|strip|product"
                         data-skus="SZM-0417|SZM-0418" data-limit="6" data-min="3" data-index="<sku index url>"> */
(function () {
  var feeds = {}, skuIndex = null;

  // Instant first paint (Toshi 10/8: the band popped in ~5 s late while the Apps Script woke up): draw from the newest of
  // (a) the copy baked into the page (snippets/szw-installs-snapshot.liquid) and (b) the last live answer this browser saw;
  // then ask the live feed in the background and redraw only if it changed.
  var KEY = 'szw-installs-v1';
  function cached() {
    try { var c = JSON.parse(localStorage.getItem(KEY) || 'null'); if (c && c.items) return c.items; } catch (e) {}
    var s = document.querySelector('[data-szw-installs-snapshot]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function feed(url) {
    if (!feeds[url]) feeds[url] = fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'gallery=1')
      .then(function (r) { return r.json(); }).then(function (d) {
        var items = d && d.ok ? d.items || [] : null;
        if (items) try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      }).catch(function () { return null; });
    return feeds[url];
  }
  function index(url) {
    if (!skuIndex) skuIndex = fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var m = {}; (d.rows || []).forEach(function (r) { m[r[0]] = { handle: r[1], variant: r[2], title: r[3], colour: r[4] }; }); return m;
    }).catch(function () { return {}; });
    return skuIndex;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function norm(s) { return String(s).toUpperCase().replace(/\s+/g, '').replace(/^([A-Z]{3})-?(\d{4}).*$/, '$1-$2'); }
  function skus(item) { return String(item.sku || '').split(/[,;/]+/).map(function (s) { return norm(s.trim()); }).filter(Boolean); }
  function link(v) {
    v = String(v || '').trim(); if (!v) return '';
    if (/^@/.test(v)) return 'https://www.instagram.com/' + v.slice(1).replace(/\/$/, '');
    if (!/^https?:\/\//.test(v)) return 'https://' + v;
    return v;
  }
  function img(u, w) { return u + '=w' + w; }
  function onWall(item, idx) {
    return skus(item).map(function (k) {
      var p = idx[k];
      return p ? '<a class="szw-inst__wall" href="/products/' + esc(p.handle) + '?variant=' + p.variant + '">' + esc(p.title) + ' <span>' + esc(k) + (p.colour ? ' · ' + esc(p.colour) : '') + '</span></a>'
               : '<span class="szw-inst__wall">' + esc(k) + '</span>';
    }).join('');
  }
  // 10/13: the designer ticked "without our names" on the share form -> credit line says so; no names anywhere for that project
  function anon(item) { return /anonymous\s*[–-]\s*shown without names/i.test(item.credit || ''); }
  function credits(item) {
    var out = [];
    if (anon(item)) return '<dl class="szw-inst__credits"></dl>';
    var f = link(item.website), ph = link(item.photographer_link);
    if (item.firm) out.push('<div><dt>Design</dt><dd>' + (f ? '<a href="' + esc(f) + '" target="_blank" rel="noopener">' + esc(item.firm) + '</a>' : esc(item.firm)) + '</dd></div>');
    if (item.architect) out.push('<div><dt>Architecture</dt><dd>' + esc(item.architect) + '</dd></div>');
    if (item.photographer) out.push('<div><dt>Photography</dt><dd>' + (ph ? '<a href="' + esc(ph) + '" target="_blank" rel="noopener">' + esc(item.photographer) + '</a>' : esc(item.photographer)) + '</dd></div>');
    return '<dl class="szw-inst__credits">' + out.join('') + '</dl>';
  }
  function card(item, idx, n) {
    var more = item.photos.length > 1 ? '<span class="szw-inst__count">' + item.photos.length + ' photographs</span>' : '';
    return '<figure class="szw-inst__card">' +
      '<button type="button" class="szw-inst__open" data-szw-open="' + n + '" aria-label="View ' + esc(item.project) + '">' +
        '<img src="' + img(item.photos[0], 900) + '" srcset="' + img(item.photos[0], 600) + ' 600w, ' + img(item.photos[0], 900) + ' 900w, ' + img(item.photos[0], 1400) + ' 1400w" sizes="(min-width: 990px) 30vw, 90vw" loading="lazy" alt="' + esc(item.project + (item.city ? ', ' + item.city : '')) + '">' + more +
      '</button>' +
      '<figcaption><p class="szw-inst__title">' + esc(item.project) + (item.city ? '<span>' + esc(item.city) + '</span>' : '') + '</p>' +
        (item.firm && !anon(item) ? '<p class="szw-inst__by">Design: ' + esc(item.firm) + '</p>' : '') + onWall(item, idx) + '</figcaption></figure>';
  }

  // Full-screen viewer: every photograph of the project, credits and the patterns on the wall beside it.
  var box, cur, list, at;
  function viewer(items, idx, n) {
    list = items; cur = n; at = 0;
    if (!box) {
      box = document.createElement('div'); box.className = 'szw-inst__box'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<button type="button" class="szw-inst__x" aria-label="Close">×</button><button type="button" class="szw-inst__prev" aria-label="Previous">‹</button>' +
        '<div class="szw-inst__stage"><img alt=""></div><button type="button" class="szw-inst__next" aria-label="Next">›</button><aside class="szw-inst__side"></aside>';
      document.body.appendChild(box);
      box.querySelector('.szw-inst__x').onclick = close;
      box.querySelector('.szw-inst__prev').onclick = function () { step(-1); };
      box.querySelector('.szw-inst__next').onclick = function () { step(1); };
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) { if (!box.classList.contains('is-open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') step(-1); if (e.key === 'ArrowRight') step(1); });
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (x0 == null) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 50) step(d < 0 ? 1 : -1); x0 = null; });
    }
    box.dataset.idx = '1'; box._idx = idx;
    draw(); box.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    box.querySelector('.szw-inst__x').focus();
  }
  function step(d) {
    var it = list[cur];
    at += d;
    if (at >= it.photos.length) { cur = (cur + 1) % list.length; at = 0; }
    else if (at < 0) { cur = (cur - 1 + list.length) % list.length; at = list[cur].photos.length - 1; }
    draw();
  }
  function draw() {
    var it = list[cur], im = box.querySelector('.szw-inst__stage img');
    im.src = img(it.photos[at], 2000); im.alt = it.project + (it.city ? ', ' + it.city : '');
    box.querySelector('.szw-inst__side').innerHTML =
      '<p class="szw-eyebrow">' + (at + 1) + ' / ' + it.photos.length + '</p><h3 class="szw-inst__boxtitle">' + esc(it.project) + '</h3>' +
      (it.city ? '<p class="szw-inst__city">' + esc(it.city) + '</p>' : '') + '<p class="szw-eyebrow">On the wall</p>' + onWall(it, box._idx) + credits(it);
  }
  function close() { box.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  function mount(el) {
    var first = cached(), shown = null;
    function go(items) {
      var key = JSON.stringify(items); if (key === shown) return; shown = key;
      index(el.dataset.index).then(function (idx) { paint(el, items, idx); });
    }
    if (first) go(first);
    feed(el.dataset.endpoint).then(function (live) { if (live) go(live); else if (!first) go([]); });
  }
  function paint(el, items, idx) {
    var mode = el.dataset.mode || 'page', limit = +el.dataset.limit || 0, min = +el.dataset.min || 1;
    // copy rule (Toshi 10/10): our leaf is not genuine gold - project names say "metal leaf", never "gold leaf"
    items = items.map(function (it) { if (it && it.project && /gold[- ]leaf/i.test(it.project)) { it = Object.assign({}, it, { project: it.project.replace(/gold[- ]leaf/ig, 'metal leaf') }); } return it; });
    (function () {
      if (mode === 'product') {
        var mine = (el.dataset.skus || '').split('|').map(norm);
        items = items.filter(function (it) { return skus(it).some(function (k) { return mine.indexOf(k) > -1; }); });
      }
      // Order (Toshi 10/5): real installations first - featured ones lead (newest first, Birdhouse) - and Studio Zen's own
      // displays ("Design: Studio Zen Wallcoverings", the D&D windows) at the bottom. Feed order (newest first) is kept inside each group.
      var own = function (it) { return /studio\s*zen/i.test(it.firm || ''); };
      if (mode !== 'product') items = items.filter(function (it) { return !own(it) && it.feature; })
        .concat(items.filter(function (it) { return !own(it) && !it.feature; }), items.filter(own));
      // "Show these first" (section setting / data-lead): named projects lead, in the order given (Toshi 10/5: Birdhouse, Kinjo).
      var lead = (el.dataset.lead || '').split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
      if (lead.length && mode !== 'product') {
        var rank = function (it) { var h = [it.project, it.firm, it.city].join(' ').toLowerCase();
          for (var j = 0; j < lead.length; j++) if (h.indexOf(lead[j]) > -1) return j; return lead.length; };
        items = items.map(function (it, n) { return [rank(it), n, it]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; });
      }
      if (limit) items = items.slice(0, limit);
      var wrap = el.closest('[data-szw-installs-wrap]') || el;
      if (items.length < min) { wrap.hidden = true; return; }
      wrap.hidden = false;
      var grid = el.querySelector('[data-szw-grid]'), empty = el.querySelector('[data-szw-empty]'), q = el.querySelector('[data-szw-q]'), count = el.querySelector('[data-szw-count]');
      function render(show) {
        grid.innerHTML = show.map(function (it) { return card(it, idx, items.indexOf(it)); }).join('');
        if (empty) empty.hidden = show.length > 0;
        if (count) count.textContent = show.length + (show.length === 1 ? ' project' : ' projects');
      }
      render(items);
      el._items = items; el._idx = idx;
      if (!grid._c) { grid._c = 1; grid.addEventListener('click', function (e) { var b = e.target.closest('[data-szw-open]'); if (b) viewer(el._items, el._idx, +b.dataset.szwOpen); }); }
      if (q && !q._c) q._c = 1, q.addEventListener('input', function () {
        var t = q.value.trim().toLowerCase().replace(/\s+/g, '');
        render(!t ? items : items.filter(function (it) {
          var hay = (anon(it) ? [it.project, it.city, it.sku] : [it.project, it.city, it.firm, it.architect, it.photographer, it.sku]).concat(skus(it).map(function (k) { return idx[k] ? idx[k].title + idx[k].colour : ''; })).join(' ').toLowerCase().replace(/\s+/g, '');
          return hay.indexOf(t) > -1 || hay.replace(/-/g, '').indexOf(t.replace(/-/g, '')) > -1;
        }));
      });
    })();
  }
  function init() { document.querySelectorAll('[data-szw-installs]').forEach(function (el) { if (!el._m) { el._m = 1; mount(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
